export const ImportWizardRoute = {
  IMPORTWIZARD: 'importwizard',
};

export const ImportWizardPathName = {
  IMPORTWIZARD: 'importwizard',
  IMPORTWIZARDFORM_NEW: 'importwizardform:new',
  IMPORTWIZARDFORM: 'importwizardform',
  IMPORTWIZARDFORM_CLONE: 'importwizardform:clone',
  IMPORTWIZARDFORM_SUB: 'importwizardform:sub',
  IMPORTWIZARDMANAGEUPLOADS: 'importwizardmanageuploads',
  IMPORTWIZARD_EMAILS: 'ImportWizardEmails',
};

export const ImportWizardSegmentEvents = {
  IMPORT_WIZARD_SAVE_EVENT: 'ImportWizardSaveEvent',
};

export const ImportWizardPseudoPath = {
  SUB: '/sub/',
};

export const GoogleSheetQuery = {
  GOOGLE_SHEET_ID: 'google-sheet-id',
};

export const DefaultIcon = 'icon-bar-chart-o';

export const FileDownloadConstants = {
  RESPONSE_TYPE_BLOB: 'blob',
  FILENAME_HEADER_KEYWORD: 'filename=',
};
